export default "/images/left-chevron.png?6269a730550e9952b6b1110be4dfdb8e";